import {
  TemplateStructureEnum,
  ConfigurationPanelStructure,
  ConfigurationPanelStructureItemEnum,
  TabItem, ComponentNameEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import {getCssPropertyByName, getResponsiveDisplay} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import {
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setResponsiveDisplayStack
} from '@/components/template-builder/setters';
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
import {restoreSmartListsOriginalCode} from "@/composables/template-editor/TemplateEditor";
import {refreshSmartProductList} from "@/components/template-builder/callbacks";
import {getTemplateIframeDocument} from "@/components/template-builder/utils/helpers";
import {HIDE_MOBILE_ATTRIBUTE} from "@/components/template-builder/utils/constants";
import getResponsiveDisplayStackFieldConfig
  from "@/components/template-builder/config/fields/responsive-display-stack-config";

export const rowTabItemConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.LINE,
  label: 'templateBuilder.configs.line',
  tabPanel: {
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.line',
        selector: 'body #spm_body table#{LINE_ID}',
        items: [
          {
            label: 'templateBuilder.fields.backgroundColor',
            selector: '{SELECTOR}',
            properties: [{ name: 'background-color', getter: getCssPropertyByName, setters: [setCssProperty] }],
            ...getColorFieldConfig('#ffffff', false, false, true),
          },
          {
            label: 'templateBuilder.fields.internalMargins',
            selector: 'body #spm_body table#{LINE_ID} > tbody > tr > td',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig('padding').options,
            },
          },
          {
            label: 'templateBuilder.fields.responsiveRow',
            selector: 'body #spm_body table#{LINE_ID}',
            displayToggle: false,
            properties: [{
              // eslint-disable-next-line max-len
              name: 'spm_responsive', getter: getResponsiveDisplay, setters: [setResponsiveDisplayStack], preCallbacks: [(widgetId: string) => restoreSmartListsOriginalCode(widgetId)], callbacks: [refreshSmartProductList],
            }],
            disableHandler: () => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true',
            disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
            ...getResponsiveDisplayStackFieldConfig('spm_responsive', ''),
          },
        ],
      },
    ],
  },
};

const rowItemConfig: ConfigurationPanelStructure = {
  items: [
    rowTabItemConfig,
  ],
};

export default rowItemConfig;
